import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page1"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
import '@/assets/v2/page1/page1.css';

// 引入图片
import logoA from '@/assets/v2/page1/logo-a.webp';
import logo from '@/assets/v2/page1/logo.webp';
import xiaozi from '@/assets/v2/page1/xiaozi.webp';
import zhubiao1 from '@/assets/v2/page1/zhubiao.webp';
import zhubiao2 from '@/assets/v2/page1/zhubiao2.webp';
export default {
  __name: 'Page1',
  setup(__props) {
    // case 0
    // 引入样式

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(logo),
        alt: "logo",
        class: "logo",
        draggable: "false"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(zhubiao1),
        alt: "zhubiao1",
        class: "zhubiao1",
        draggable: "false"
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: _unref(xiaozi),
        alt: "xiaozi",
        class: "xiaozi",
        draggable: "false"
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: _unref(logoA),
        alt: "logoA",
        class: "logoA",
        draggable: "false"
      }, null, 8, _hoisted_5)]);
    };
  }
};